<template>
  <div
    :class="[
      'saved-filters__modal',
      { 'saved-filters__modal--empty': !savedFilters.length },
    ]">
    <modal
      :active="true"
      :primary-button-disabled="!savedFilters.length || isLoading"
      :delete-button-disabled="!savedFilters.length || isLoading"
      :tertiary-button-label="savedFilters.length ? 'Cancel' : ''"
      :primary-button-label="savedFilters.length ? 'Confirm' : ''"
      :show-delete-button-icon="true"
      delete-button-label="Delete"
      size="small"
      @onDelete="handleDelete()"
      @onClose="onClose()"
      @onConfirm="onSave()">
      <template #header>
        <p>Apply Saved Filter</p>
      </template>
      <template #content>
        <div class="saved-filters__modal__body">
          <loading-indicator
            v-if="isLoading"
            :loading="true"
            label="Fetching applied filters..." />
          <div
            v-else-if="savedFilters && savedFilters.length"
            class="saved-filters__modal__body__filters">
            <dropdown-with-button
              id="saved-filter"
              :options="savedFilters"
              :selected-filter="selectedFilter"
              @onChange="handleFilterChange($event)"
              @onDelete="handleDelete()" />
          </div>
          <p v-else>No results found.</p>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import DropdownWithButton from "@/components/common/Dropdown/DropdownWithButton";

export default {
  name: "SavedFilterModal",
  components: {
    DropdownWithButton,
  },
  props: {
    savedFilters: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: true },
  },
  data() {
    return {
      selectedFilter: this.savedFilters?.length ? this.savedFilters[0] : null,
      hasValidationError: false,
    };
  },
  watch: {
    savedFilters() {
      this.selectedFilter = this.savedFilters?.length
        ? this.savedFilters[0]
        : null;
    },
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
    onSave() {
      if (this.selectedFilter) {
        this.$parent.$emit("onApplySavedFilter", this.selectedFilter);
        this.$parent.toggleSavedFilterModal();
      } else {
        this.hasValidationError = true;
      }
    },
    handleFilterChange({ value: selectedFilter }) {
      this.selectedFilter = selectedFilter;
      this.hasValidationError = false;
    },
    async handleDelete() {
      if (this.selectedFilter) {
        const { filter_title } = this.selectedFilter;
        this.$parent.$emit("onSavedFilterDelete", filter_title);
      }
    },
  },
};
</script>

<style lang="scss">
.saved-filters__modal {
  &--empty {
    & .modal--small {
      height: 10rem;
    }
  }
  &__body {
    &__filters {
      position: fixed;
      z-index: 99;

      & .form-group {
        position: absolute;
        width: 352px;
      }
      & .vs__dropdown-menu {
        max-height: 160px;
      }
    }
  }
}
</style>
